export default __webpack_public_path__ + "static/media/sulekha-logo.ce0b1fa0.webp";